import { render, staticRenderFns } from "./NewChart.vue?vue&type=template&id=706348b8&"
import script from "./NewChart.vue?vue&type=script&lang=js&"
export * from "./NewChart.vue?vue&type=script&lang=js&"
import style0 from "./NewChart.vue?vue&type=style&index=0&id=706348b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports